import { createContext } from 'react';

import type { UserAgentFlags } from '@rover/types';

const DeviceContext = createContext<UserAgentFlags>({
  isAndroid: false,
  isDesktop: false,
  isEmbedded: false,
  isiOS: false,
  isMobile: false,
  isTablet: false,
});

export default DeviceContext;
